import { Component, input, output, signal } from '@angular/core';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidButton } from '../../components/rid-button/rid-button';
import { RidFeedbackToast } from '../../components/rid-feedback-toast/rid-feedback-toast';
import { RidInstructionModal } from '../../components/rid-instruction-modal/rid-instruction-modal';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidModalBackground } from '../../components/rid-modal-background/rid-modal-background';
import { RidRatingModal } from '../../components/rid-rating-modal/rid-rating-modal';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidWordMatrices } from '../../components/rid-word-matrices/rid-word-matrices';
import { PluralPipe } from '../../pipes/plural.pipe';

@Component({
  selector: 'rid-reading-matrix-stopwatch',
  imports: [
    PluralPipe,
    RidButton,
    RidTopBar,
    RidMechanicBackground,
    RidRatingModal,
    RidFeedbackToast,
    RidInstructionModal,
    RidMechanicTitle,
    RidMechanicWrapper,
    RidMechanicContent,
    RidWordMatrices,
    RidModalBackground,
    RidBottomButton,
  ],
  templateUrl: './rid-reading-matrix-stopwatch.html',
  host: {
    class: 'block',
  },
})
export class RidReadingMatrixStopwatch {
  matrices = input.required<string[][][]>();
  previousDuration = input<number>();

  index = signal(0);
  state = signal<
    { type: 'INSTRUCTION' } | { type: 'READING' } | { type: 'FEEDBACK'; duration: number } | { type: 'RATING' } | { type: 'VIEWING' }
  >({
    type: 'INSTRUCTION',
  });

  finished = output<void>();

  startTime = new Date();
  endTime: Date | undefined;

  start() {
    this.startTime = new Date();
    this.state.set({ type: 'READING' });
  }

  finishReading() {
    this.endTime = new Date();
    const duration = Math.round((this.endTime.getTime() - this.startTime.getTime()) / 1000);
    this.state.set({ type: 'FEEDBACK', duration });
  }

  finish() {
    this.finished.emit();
  }
}
